/* tslint:disable:no-identical-functions */

import {
  ProductListConfigurationKeys,
  ProductListConfigurations,
  PRODUCT_LIST_NAMESPACE,
} from '@epicuro-next/constants/rule-engine/product-list-rules';
import {
  getValueFromConfigState,
  selectConfigurationsState,
  selectConfigurationValueFrom,
} from '@epicuro-next/platform/configuration';
import { createSelector } from '@ngrx/store';

import { COMMERCIAL_LIST_LIMIT } from '../../utils/constants';

export const selectCommercialProductListEnabled = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      ProductListConfigurationKeys.EnableCommercialProductList,
      ProductListConfigurations
    >(
      config,
      PRODUCT_LIST_NAMESPACE,
      ProductListConfigurationKeys.EnableCommercialProductList,
      false,
    );
  },
);

export const selectCommercialProductListConsumptionEnabled = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      ProductListConfigurationKeys.EnableCommercialProductListConsumption,
      ProductListConfigurations
    >(
      config,
      PRODUCT_LIST_NAMESPACE,
      ProductListConfigurationKeys.EnableCommercialProductListConsumption,
      false,
    );
  },
);

export const selectCommercialProductListDateChangeEnabled = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      ProductListConfigurationKeys.EnableCommercialProductListDateChange,
      ProductListConfigurations
    >(
      config,
      PRODUCT_LIST_NAMESPACE,
      ProductListConfigurationKeys.EnableCommercialProductListDateChange,
      false,
    );
  },
);

export const selectCommercialListLimit = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      ProductListConfigurationKeys.CommercialListLimit,
      ProductListConfigurations
    >(
      config,
      PRODUCT_LIST_NAMESPACE,
      ProductListConfigurationKeys.CommercialListLimit,
      COMMERCIAL_LIST_LIMIT,
    );
  },
);

export const selectCommercialListMultiplierEnabled = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      ProductListConfigurationKeys.CommercialListMultiplierEnabled,
      ProductListConfigurations
    >(
      config,
      PRODUCT_LIST_NAMESPACE,
      ProductListConfigurationKeys.CommercialListMultiplierEnabled,
      false,
    );
  },
);

export const selectCommercialListValidationMessageDisplaySizeId =
  selectConfigurationValueFrom<
    ProductListConfigurationKeys.CommercialListValidationMessageDisplaySizeId,
    ProductListConfigurations
  >(
    PRODUCT_LIST_NAMESPACE,
    ProductListConfigurationKeys.CommercialListValidationMessageDisplaySizeId,
    false,
  );
